import Vue from 'vue'

export const userKey = '__knowledge_user'
// API AVALIZE
export const baseApiUrl = 'https://avalize.intelite.com.br/api/'

// API MULTINTEGRADA
// export const baseApiUrl = 'https://multintegrada.intelite.com.br/api/'

// export const baseApiUrl = 'http://localhost:3003/api/'

export function showError(e) {
    if(e && e.response && e.response.data) {
        Vue.toasted.global.defaultError({ msg : e.response.data })
    } else if(typeof e === 'string') {
        Vue.toasted.global.defaultError({ msg : e })
    } else {
        Vue.toasted.global.defaultError()
    }
}

export default { baseApiUrl, showError, userKey }